import React, { useEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Formalization.scss';
import i18n from '../../../../i18n';
import { gaEvent, trackGA } from 'services/ga';

const roomTypes = {
  apartmentRoom: i18n.t('components.building.main.formalization.apartmentRoom'),
  apartRoom: i18n.t('components.building.main.formalization.apartRoom'),
  zhiloeRoom: i18n.t('components.building.main.formalization.zhiloeRoom'),
  partFlat: i18n.t('components.building.main.formalization.partFlat'),
  nezhiloeRoom: i18n.t('components.building.main.formalization.nezhiloeRoom'),
  zhiloeHouse: i18n.t('components.building.main.formalization.zhiloeHouse'),
  commercialPremises: i18n.t('components.building.main.formalization.commercialPremises'),
  hotelRoom: i18n.t('components.building.main.formalization.hotelRoom'),
  parking: i18n.t('components.building.main.formalization.parking'),
  storageRoom: i18n.t('components.building.main.formalization.storageRoom')
};

const Formalization = ({ className, building, client, print, objectType, profile }) => {
  const { room_types: roomType, count_flats } = building.data;

  const { t } = useTranslation();

  let roomTypeNames = [];
  if (roomType) {
    roomTypeNames = roomType
      .filter(type => roomTypes[type])
      .map(type => t(`components.building.main.formalization.${type}`))
      .sort((a, b) => a.localeCompare(b));
  }


  const handleTrackEvent = () => {
    const { title, id } = building.data;

    trackGA(gaEvent.buildingInfoBlocksShow({
      eventLabel: 'oformlenie',
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  useEffect(() => {
    handleTrackEvent();
  }, []);

  return (
    <div className={cn(styles.Formalization, { [styles.Client]: client }, className, { [styles.FormalizationPrint]: print })}>
      <h3 className={client ? styles.TitleClient : styles.Title}>
        {t('components.building.main.formalization.title')}
      </h3>
      <div className={client ? styles.InnerClient : styles.Inner}>
        <div className={styles.Row}>
          <div className={styles.Label}>
            {t('components.building.main.formalization.label')}
          </div>
          <div className={styles.Name}> {`${building.data.checkout ? `${building.data.checkout}` : ''} ${building.data.checkout2}`} </div>
        </div>

        {count_flats && roomTypeNames.length > 0 ? (
          <div className={styles.Row}>
            <div className={styles.Label}>
              {t('components.building.main.formalization.type')}
            </div>
            <div className={cn(styles.Name, styles.RoomTypes)}>
              {roomTypeNames.map((name, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <br />}
                  <span>{name}</span>
                </React.Fragment>
              ))}
            </div>
          </div>
        ) : null}

        {/* count_flats ? (
          <div className={styles.Row}>
            <div className={styles.Label}>
              {t('components.building.main.formalization.sum')}
            </div>
            <div className={styles.Name}>
              {building.data.contract_total
                ? t('components.building.main.formalization.full')
                : t('components.building.main.formalization.part')
              }
            </div>
          </div>
        ) : null */}
      </div>
    </div>
  );
};

export default Formalization;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Formalization/Formalization.js